export default "__VITE_ASSET__eRXOvj9O__"